export default "__VITE_ASSET__BbQzm31R__"